import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import { ISuggestion } from 'interfaces/IGeoSearchStore';

import setUrlParam from 'utils/setUrlParam';

import Autosuggest from 'ati-ui-react/components/Autosuggest';
import SearchParameter from '../SearchParameter/SearchParameter';

const GeoSuggest: FC = observer(() => {
  const {
    geoSearchStore,
    findTrucksStore: { updateGeo },
  } = useStores();

  const handleSuggestionsFetchRequested = (geo: any): void => {
    geoSearchStore.getGeoValue(geo, 7);
  };

  const handleSuggestionSelected = (
    event: any,
    { suggestion }: { suggestion: ISuggestion },
  ): void => {
    const { type, address, city, region, country } = suggestion;
    const city_id = city?.id;
    const region_id = region?.id;
    const country_id = country?.id;

    const city_name = city?.name;
    const region_name = region?.name;
    const country_name = country?.name;

    const name = city_name || region_name || country_name;

    updateGeo({
      id: city_id ? String(city_id) : '',
      name,
      country_id,
      region_id,
      type,
    });

    // NOTE: Нет времени разбираться как это работает, сделал также как было раньше
    setUrlParam({
      field: 'geo',
      value: `${city_id}_${address}_${country_id}_${region_id}_${type}`,
    });
  };

  const handleSuggestionsClearRequested = () => {
    if (geoSearchStore.value === '') {
      updateGeo({});
      setUrlParam({ field: 'geo', value: 0 });
    }
  };

  return (
    <>
      <SearchParameter caption="Город" geosuggest>
        <Autosuggest
          id=""
          placeholder="Например, Москва"
          searchProperty="address"
          valueProperty="address"
          value={geoSearchStore.value}
          onChange={geoSearchStore.onChange}
          onSuggestionsFetchRequested={handleSuggestionsFetchRequested}
          suggestions={geoSearchStore.suggestions}
          noFog
          onSuggestionSelected={handleSuggestionSelected}
          onSuggestionsClearRequested={handleSuggestionsClearRequested}
        />
      </SearchParameter>
    </>
  );
});

export default GeoSuggest;
